import { Table, Tag, Typography, Spin, message } from 'antd';
import { useEffect, useState } from 'react';
import { get } from '../../../axios/axios';
import { useDistributionContext } from '../contexts/DistributionContext';

const { Title } = Typography;

const WithdrawRecords = () => {
    const { registerRefresh } = useDistributionContext();
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    // 获取 token
    const getToken = () => {
        try {
            const userInfo = localStorage.getItem('CommissionUserInfo');
            if (userInfo) {
                const parsed = JSON.parse(userInfo);
                return parsed?.['Commission-Token'];
            }
        } catch (error) {
            console.error('获取token失败:', error);
        }
        return null;
    };

    // 获取提现记录列表
    const fetchWithdrawRecords = async () => {
        const token = getToken();
        if (!token) {
            message.error('请先登录');
            return;
        }

        setLoading(true);
        try {
            const res = await get(
                '/member/commission/withdraw/list',
                {},
                {
                    headers: {
                        'Commission-Token': token,
                    },
                },
            );

            if (res && res.success && res.data) {
                setDataSource(res.data);
            } else {
                message.error(res?.msg || '获取提现记录失败');
            }
        } catch (error) {
            console.error('获取提现记录失败:', error);
            // 错误信息已经在axios拦截器中通过message.error显示了
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWithdrawRecords();
    }, []);

    // 注册刷新函数
    useEffect(() => {
        const unregister = registerRefresh('withdrawRecords', fetchWithdrawRecords);
        return unregister;
    }, [registerRefresh]);

    // 状态标签映射
    const getStatusTag = (status) => {
        const statusMap = {
            0: { text: '提现中', color: 'processing' },
            1: { text: '已完成', color: 'success' },
            2: { text: '已取消', color: 'default' },
        };
        const statusInfo = statusMap[status] || { text: '未知', color: 'default' };
        return <Tag color={statusInfo.color}>{statusInfo.text}</Tag>;
    };

    // 格式化金额
    const formatAmount = (amount) => {
        if (amount === null || amount === undefined) return '-';
        return `¥${Number(amount).toFixed(2)}`;
    };

    // 表格列配置
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '提现金额',
            dataIndex: 'withdrawAmount',
            key: 'withdrawAmount',
            width: 120,
            render: (amount) => formatAmount(amount),
        },
        {
            title: '提现方式',
            dataIndex: 'withdrawTypeDesc',
            key: 'withdrawTypeDesc',
            width: 120,
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) => getStatusTag(status),
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 180,
        },
    ];

    return (
        <div className="p-4">
            <Title level={4} style={{ marginBottom: 16 }}>
                提现记录
            </Title>
            <Spin spinning={loading}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    rowKey="id"
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showTotal: (total) => `共 ${total} 条记录`,
                    }}
                />
            </Spin>
        </div>
    );
};

export default WithdrawRecords;
